import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "persenSetting",
  "use": "persenSetting-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"persenSetting\"><path d=\"M157.1 57.1h-26.5c-2.4 0-4.4-2-4.4-4.4 0-2.4 2-4.4 4.4-4.4h26.5c2.4 0 4.4 1.9 4.4 4.3v.1c0 2.4-2 4.4-4.4 4.4zm0 23.1h-34.6c-2.4 0-4.4-2-4.4-4.4 0-2.4 2-4.4 4.4-4.4h34.6c2.4 0 4.4 2 4.4 4.4 0 2.5-1.9 4.4-4.4 4.4zm0 22.4H133c-2.4 0-4.4-2-4.4-4.4 0-2.4 2-4.4 4.4-4.4h24.2c2.4 0 4.4 2 4.4 4.4-.1 2.4-2 4.4-4.5 4.4zm0 23.1h-15.3c-2.4 0-4.4-2-4.4-4.4 0-2.4 2-4.4 4.4-4.4h15.3c2.4 0 4.4 2 4.4 4.4 0 2.5-1.9 4.4-4.4 4.4zm0 22.3h-21.7c-2.4 0-4.4-2-4.4-4.4 0-2.4 2-4.4 4.4-4.4h21.7c2.4 0 4.4 2 4.4 4.4 0 2.4-1.9 4.4-4.4 4.4zM35 144.9c0-19.2 10.7-35.9 26-43.4 6.1 3.3 12.2 5.8 19.8 5.8s13.7-2.5 19.9-6.7c15.3 7.5 26 24.2 26 43.4-.1 20.9-91.7 20.9-91.7.9zM102.2 94l9-22.9c.2 17.2-13.5 31.2-30.7 31.5-17.2.1-31.2-13.6-31.5-30.8V71c.2-17.2 14.3-30.9 31.5-30.7 16.8.2 30.4 13.8 30.7 30.7l-9 23z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/persenSetting.svg
// module id = FgUF
// module chunks = 6